import moment from 'moment';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Holiday } from 'api/holiday-calendar/types';
import { DateFromTo } from 'components/atoms/date-from-to';
import { humanise } from 'components/atoms/humanised-date';

interface Props {
  holiday: Holiday[] | undefined;
}

const HolidatContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: var(--spacing-03) 0;
  min-width: 100px;
`;

const DateValue = styled.div`
  display: flex;
`;

const DateStyle = styled.div`
  font-weight: var(--heading-8-weight);
  margin-right: var(--spacing-02);
`;

const HolidayText = styled.div`
  font-style: italic;
`;

const renderer = (holidayValue: Holiday): React.ReactNode => {
  if (holidayValue.holidayStart === '' && holidayValue.holidayEnd === '') {
    return null;
  }
  if (holidayValue.holidayStart === holidayValue.holidayEnd) {
    return <DateStyle>{humanise(moment(holidayValue.holidayEnd))}</DateStyle>;
  }

  return (
    <DateStyle>
      <DateFromTo
        from={moment(holidayValue.holidayStart)}
        to={moment(holidayValue.holidayEnd)}
      />
    </DateStyle>
  );
};

const TootltipContent = ({ holiday }: { holiday: Holiday }) => {
  const { holidayName } = holiday;

  return (
    <HolidatContainer>
      <DateValue>
        {renderer(holiday)}
        (<FormattedMessage id="holiday" />)
      </DateValue>
      <HolidayText>&quot;{holidayName}&quot;</HolidayText>
    </HolidatContainer>
  );
};

export const GetHolidayTooltipContent: React.FC<Props> = ({ holiday }) => {
  if (!holiday) {
    return null;
  }

  return (
    <>
      {holiday.map((holidayValue) => (
        <TootltipContent holiday={holidayValue} />
      ))}
    </>
  );
};
